<script>
import AawzMarkdownRender from '@modules/global/components/aawz-markdown-render/aawz-markdown-render.vue'
import IaPainelLateral from '@modules/global/components/ia-painel-lateral/ia-painel-lateral.vue'
import EmptyMessages from '@modules/aawz-intelligence-v2/components/empty-messages/empty-messages.vue'
import SendMessage from '@modules/aawz-intelligence-v2/components/send-message/send-message.vue'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import {
  apiFeeFixoIa,
  montarContexto,
  FEE_FIXO_IA_STORE,
} from '@modules/fee-fixo/api/apiFeeFixoIa'
import { provedorDeContextoDeTela } from '@modules/aawz-intelligence-v2/utils/provedor-de-contexto-de-tela'
import { provedorDeContextoDeExecucao } from '@modules/aawz-intelligence-v2/utils/contexto-de-execucao'
import { desregistrarProvedoresDoApiChat } from '@modules/aawz-intelligence-v2/utils/provedores-do-api-chat'
import { nomeUtil } from '@modules/fee-fixo/constants/Text'
import { apiFeeFixoRelatorio } from '@modules/fee-fixo/api/apiFeeFixoRelatorio'
import FeeFixoIaEnvioRelatorio from '@modules/fee-fixo/components/fee-fixo-ia-envio-relatorio/fee-fixo-ia-envio-relatorio.vue'
import PartesDoTurno from '@modules/aawz-intelligence-v2/ui-registry/partes-do-turno/partes-do-turno.vue'
import FeeFixoGuiaSimulacaoCard from '@modules/fee-fixo/components/fee-fixo-guia-simulacao-card/fee-fixo-guia-simulacao-card.vue'
// ★ O MESMO slice que o Guia usa (`views/guia/view-fee-fixo-guia.vue` faz o
// mesmo spread). Reusar, e não recopiar, porque a ordem depositar → confirmar
// é CONTRATO entre dois repos: o commit exige os `resultados` que `simulate(S)`
// calcula no navegador, e a frase só pode ir depois do depósito responder 200.
// Uma segunda cópia da regra divergiria no primeiro ajuste do protocolo.
import * as simulacaoDaConversa from '@modules/fee-fixo/views/guia/view-fee-fixo-guia-simulacao'
import { CHAVES_COM_DONO_NO_MODULO } from '@modules/fee-fixo/ia/registry'
import { anexosDaMensagem } from '@modules/aawz-intelligence-v2/utils/anexos-da-mensagem'
import { paraItemDeAnexo } from '@modules/aawz-intelligence-v2/utils/anexo-persistido-para-item'
import ComposerAttachments from '@modules/aawz-intelligence-v2/components/composer-attachments/composer-attachments.vue'

const PLACEHOLDER_COMPOSER = 'Pergunte sobre a migração deste cliente…'

const ERRO_ENVIO_GENERICO =
  'Não foi possível enviar o relatório. Tente novamente em instantes.'

// Perguntas de partida. São as que o consultor faz na reunião — todas
// respondidas com número de tool, nunca de texto gerado (spec-003 US-2).
const SUGESTOES = [
  'Em quanto tempo o fee-based fica mais barato para este cliente?',
  'Como explico que o primeiro ano é mais caro?',
  'Quais são as premissas do modelo e o que muda se eu alterá-las?',
  'Em que casos o fee-based NÃO compensa?',
]

export default {
  name: 'FeeFixoIaEspecialista',
  components: {
    IaPainelLateral,
    EmptyMessages,
    SendMessage,
    AawzMarkdownRender,
    FeeFixoIaEnvioRelatorio,
    FeeFixoGuiaSimulacaoCard,
    PartesDoTurno,
    ComposerAttachments,
  },
  data() {
    return {
      ...simulacaoDaConversa.data(),
      mensagem: '',
      sugestoes: SUGESTOES,
      // Estado do card de envio (spec-005). Fica aqui, e não na store, porque é
      // do ciclo de vida desta tela: um F5 no meio da geração não deve deixar
      // um card órfão em "enviando".
      envioEtapa: '',
      envioResolvido: '',
      envioErro: '',
      envioResultado: null,
    }
  },
  computed: {
    ...simulacaoDaConversa.computed,
    // Na store junto com a conversa: o componente é remontado a cada troca de
    // aba (`key` do RouterView em src/app.vue:50), e um `aberto` local faria o
    // painel fechar sozinho a cada navegação — o consultor teria de reabrir em
    // toda tela para reencontrar a conversa que nunca se perdeu.
    aberto() {
      return this.$store.getters['feeFixoIa/painelAberto']
    },
    mensagens() {
      return this.$store.getters['feeFixoIa/messages']
    },
    /**
     * `mensagens`, com o bloco técnico de anexos (spec-016 [T023-back]) já
     * separado do texto do usuário.
     *
     * ★ Depois do F5 o `content` persistido carrega, ao FINAL, o bloco
     * "[Anexos desta mensagem…] - arquivo (mime, N bytes): upload_id=…" — o
     * modelo precisa dele nos turnos seguintes, mas o consultor NÃO escreveu
     * aquilo. Sem este mapeamento a bolha mostrava o bloco cru na tela.
     *
     * Mapeado aqui (não no template, regra do repo: nenhuma chamada de
     * função por item do `v-for`) e só quando há bloco de verdade — as
     * demais mensagens seguem o MESMO objeto de sempre.
     */
    mensagensParaExibir() {
      return this.mensagens.map((msg) => {
        if (msg.role !== 'user') return msg
        const separado = anexosDaMensagem(msg.content)
        if (!separado.anexos.length) return msg
        return {
          ...msg,
          content: separado.texto,
          // [S-3, design-conformance 05/09] Mesmo shape que `ComposerAttachments`
          // já usa para o anexo AO VIVO no chat do CRM — a mesma unificação de
          // `chat-message.vue`, aqui na segunda superfície.
          itensAnexosPersistidos: separado.anexos.map(paraItemDeAnexo),
        }
      })
    },
    carregando() {
      return this.$store.getters['feeFixoIa/chatLoading']
    },
    respostaEmCurso() {
      return this.$store.getters['feeFixoIa/responseTokens']
    },
    ferramentasEmUso() {
      return this.$store.getters['feeFixoIa/toolCalls']
    },
    /**
     * As partes de tool do turno — o que faz o cartão de ação APARECER aqui
     * ([I-1] do review do PR #2086).
     *
     * O slice é o mesmo do chat do CRM (`toolPartsOrdenadas`), no namespace
     * DESTA superfície. Sem esta leitura, uma ação em `modo: 'oferecer'` (o
     * default) ou recusada pelo guard fazia o `upsertToolPart` e parava aí: nem
     * botão, nem motivo, nem aviso ao modelo — registrar o provedor de execução
     * (que já estava feito) só vale com o cartão desenhado.
     */
    partesDoTurno() {
      return this.$store.getters['feeFixoIa/toolPartsOrdenadas'] || []
    },
    /**
     * Os cartões do módulo que NÃO são desenhados pelo renderizador ([I-11]).
     *
     * Este painel desenha o `envio-relatorio` logo abaixo (`previewEnvio`), e a
     * store é COMPARTILHADA com o Guia — as outras cinco chaves têm dono nas
     * telas do módulo. Deixá-las passar aqui punha o cartão do registry ao lado
     * do cartão da tela que a store acabou de alimentar.
     *
     * DERIVADO do registry do módulo, nunca uma lista literal.
     */
    chavesDesenhadasPelaTela() {
      return CHAVES_COM_DONO_NO_MODULO
    },
    /**
     * A última fala do agente — de onde as partes voltam na conversa REABERTA
     * (o slice é do turno; o `tool_calls[]` da mensagem é o que sobrevive).
     */
    ultimaMensagemDoAgente() {
      const mensagens = this.mensagens || []
      for (let i = mensagens.length - 1; i >= 0; i--) {
        if (mensagens[i] && mensagens[i].role !== 'user') return mensagens[i]
      }
      return null
    },

    /**
     * Preview de envio pendente, ou null.
     *
     * A store é compartilhada com o protocolo de write-tool do IA CRM, então a
     * checagem por `preview_envio` é obrigatória: um preview de "criar tarefa"
     * não pode abrir o card de e-mail.
     */
    previewEnvio() {
      const pendente = this.$store.getters['feeFixoIa/pendingConfirmation']
      if (!pendente || !pendente.preview_envio) return null
      return pendente
    },
    conversationId() {
      return this.$store.getters['feeFixoIa/conversationId']
    },
    semMensagens() {
      return this.mensagens.length === 0 && !this.carregando
    },
    // Onde o consultor está e quem está em foco — vai junto da pergunta, mas
    // não aparece na bolha dele.
    contextoDaTela() {
      return montarContexto({
        routeName: this.$route ? this.$route.name : '',
        codigoCliente: this.$store.getters['feeFixo/clienteAtivoCodigo'],
        nomeCliente: this.$store.getters['feeFixo/clienteAtivoNome'],
      })
    },
    // O rascunho que a tela do Fee Lab publicou (spec-014). Vai junto de toda
    // pergunta feita com aquela tela aberta — é o que dispensa o "guarde o
    // cenário antes" justamente no momento em que a ajuda seria útil. Fora do
    // Fee Lab é `null`, e a pergunta segue como sempre.
    rascunhoDaTela() {
      return this.$store.getters['feeFixoIa/rascunhoDaTela']
    },
    rotuloContexto() {
      const codigo = this.$store.getters['feeFixo/clienteAtivoCodigo']
      if (!codigo) return 'Sem cliente em foco'
      // Só exibição: a store segue guardando o nome cru que o Fee Lab consome.
      const nome = nomeUtil({
        nome: this.$store.getters['feeFixo/clienteAtivoNome'],
        codigo,
      })
      return nome ? `${nome} · ${codigo}` : `Cliente ${codigo}`
    },
    /**
     * O cliente que vai RECEBER a carteira anexada — `app_clientes.id`
     * (spec-016 T023 adendo S-3).
     *
     * ★ `clienteAtivoCodigo`/`Nome` são só EXIBIÇÃO (código de corretora,
     * usado pelo `rotuloContexto` acima); o upload precisa do `id_cliente_app`
     * numérico, que vem em `clienteAtivoDetalhe` — o item de linha que
     * `focarCliente` gravou (`view-fee-fixo-clientes.vue`: "o item da tabela
     * já traz o detalhe: auc, nome, id_cliente_app"). Sem cliente ativo (ou
     * detalhe sem o campo — ex. testes que só gravam `codigo`/`nome`),
     * `null`: mesmo estado "sem cliente" que `send-message-anexos-upload-
     * mixin.js` já trata (aviso no composer, upload não dispara).
     */
    idClienteAnexo() {
      const detalhe = this.$store.getters['feeFixo/clienteAtivoDetalhe']
      return (detalhe && detalhe.id_cliente_app) || null
    },
    // Quantidade — o watch é sobre o número, não sobre o array. Durante o
    // streaming chegam dezenas de updates por segundo e um deep watch aqui
    // custaria caro só para rolar a lista.
    totalMensagens() {
      return this.mensagens.length
    },
    tamanhoResposta() {
      return this.respostaEmCurso.length
    },

    // Guard no padrão do módulo: o Vuex do central-config é registrado
    // dinamicamente, e ler o getter antes disso estouraria.
    tourGuiadoAtivo() {
      const getters = (this.$store && this.$store.getters) || {}
      return !!getters['centralConfig/tourAtivo']
    },
    placeholderDoComposer() {
      return PLACEHOLDER_COMPOSER
    },
  },
  watch: {
    totalMensagens() {
      this.rolarParaOFim()
    },
    tamanhoResposta() {
      this.rolarParaOFim()
    },

    // Aberto, este painel ESCONDE os alvos do tour: a Simulação recolhe
    // IA/Ensaiar/Gerar relatório num "Mais ações" quando ele ocupa a tela
    // (`v-if="!especialistaAberto"`), e o passo que manda clicar em "Gerar
    // relatório" ficava sem furo, apontando um botão que não está lá (medido em
    // tela, 14/08). Recolher é o mesmo tratamento que o tour já dá ao drawer da
    // Jornada — e pelo mesmo motivo, não por estética.
    tourGuiadoAtivo(agora) {
      if (agora && this.aberto) this.$store.dispatch('feeFixoIa/fecharPainel')
    },

    // A lista de mensagens só EXISTE com o painel aberto (`v-if` na casca), e
    // por isso os watches acima não tinham onde rolar enquanto ele estava
    // recolhido: reabrir caía no topo da conversa, e o consultor tinha de rolar
    // à mão até onde tinha parado. A conversa segue viva no store o tempo inteiro
    // — só o DOM é que vai embora.
    aberto(agora) {
      if (agora) this.rolarParaOFim()
    },
  },
  created() {
    // Contexto de tela (US-5 da spec-001 `plataforma-por-chat`): a tela aberta
    // viaja com toda mensagem. O provedor é INJETADO aqui porque `api/apiChat.js`
    // não pode importar `@router` — o import fecha um ciclo que quebra o
    // `extends APIChat` do fee-fixo (ver `utils/contexto-de-tela.js`).
    // Guardados na instância para o teardown desregistrar SÓ os desta superfície.
    this._provedoresDoApiChat = {
      contextoDeTela: provedorDeContextoDeTela(this, FEE_FIXO_IA_STORE),
      contextoDeExecucao: provedorDeContextoDeExecucao(this),
    }
    apiFeeFixoIa.setContextoDeTelaProvider(this._provedoresDoApiChat.contextoDeTela)
    // Contexto de EXECUÇÃO (US-4): o router e a store desta superfície, para as
    // tools de front (`navegar`, `abrir_cliente`, `preencher`, `destacar`).
    // Provedor SEPARADO do de tela porque aquele é serializado no corpo do
    // `POST /chat` — o router não pode ir junto ([T015]).
    apiFeeFixoIa.setContextoDeExecucaoProvider(this._provedoresDoApiChat.contextoDeExecucao)
    GlobalBus.$on(MODAL.FEE_FIXO_IA_ESPECIALISTA, this.abrir)
  },
  // Mesmo motivo do watch acima, pelo outro caminho: o componente é destruído e
  // recriado a cada troca de aba do módulo (`key` do RouterView em
  // `src/app.vue:50`), e aberto ele remonta com a lista no topo.
  mounted() {
    if (this.aberto) this.rolarParaOFim()
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.FEE_FIXO_IA_ESPECIALISTA, this.abrir)
    // Sem isto os provedores seguravam `this` de uma instância morta (guarda da tool em voo: no util).
    desregistrarProvedoresDoApiChat(apiFeeFixoIa, this._provedoresDoApiChat)
  },
  methods: {
    ...simulacaoDaConversa.methods,
    /**
     * Gera o relatório e envia — a ação irreversível do módulo.
     *
     * Só chega aqui pelo clique do consultor no card. O agente prepara o texto;
     * quem dispara é ele (ADR-001 da spec-005).
     */
    async enviarRelatorio({ destinatario } = {}) {
      if (this.envioEtapa) return
      const preview = this.previewEnvio
      if (!preview) return

      this.envioErro = ''
      this.envioResolvido = ''
      this.envioEtapa = 'gerando'

      const r = await apiFeeFixoRelatorio.gerarEEnviar({
        analiseId: preview.analise_id,
        idClienteApp: preview.id_cliente_app,
        destinatario,
        onProgresso: (etapa) => {
          this.envioEtapa = etapa
        },
      })

      this.envioEtapa = ''
      if (r && r.status === 200) {
        this.envioResolvido = 'enviado'
        this.envioResultado = (r && r.value) || { destinatario }
      } else {
        this.envioResolvido = 'erro'
        // Mensagem vazia viraria "Erro inesperado" genérico no card.
        this.envioErro = (r && r.message) || ERRO_ENVIO_GENERICO
      }
      return r
    },

    cancelarEnvio() {
      this.envioEtapa = ''
      this.envioResolvido = ''
      this.envioErro = ''
      this.envioResultado = null
      this.$store.dispatch('feeFixoIa/resetPendingConfirmation')
    },

    abrir(payload) {
      this.$store.dispatch('feeFixoIa/abrirPainel')
      const pergunta = payload && payload.pergunta ? payload.pergunta : ''
      if (pergunta) this.enviarPergunta(pergunta)
    },
    // Recolhe o painel pra aba lateral — não é mais um "fechar" de verdade
    // (não há popup pra dispensar): o consultor sempre tem a aba disponível
    // pra reabrir. Mesmo action Vuex de antes, só o rótulo/ícone mudam.
    fechar() {
      this.$store.dispatch('feeFixoIa/fecharPainel')
    },
    alternar() {
      this.$store.dispatch('feeFixoIa/alternarPainel')
    },
    novaConversa() {
      if (this.carregando) return
      this.$store.dispatch('feeFixoIa/limparConversa')
      this.mensagem = ''
    },
    // `@send` do composer emite `(valor, arquivosCrus, anexosProntos)`
    // (spec-016 T023 adendo S-3). Vai o `valor` emitido, não `this.mensagem`:
    // no envio só com anexo o campo está vazio e o composer já esvaziou a
    // fila — o texto de continuação que ele emite é o que evita perder o
    // arquivo. `arquivosCrus` (`File[]`) fica de fora: é só para a bolha do
    // consultor, que este painel não desenha diferente.
    enviarDigitado(valor, _arquivosCrus, anexosProntos) {
      return this.enviarPergunta(valor, { anexos: anexosProntos })
    },
    /**
     * @param {string} texto O que vai para o MODELO.
     * @param {Object} [opcoes]
     * @param {string} [opcoes.exibir] O que o consultor LÊ no thread, quando é
     *   diferente do que o servidor recebe.
     * @param {Array}  [opcoes.anexos] Uploads JÁ concluídos do composer
     *   (spec-016 T023 adendo S-3) — repassado direto para `apiFeeFixoIa.
     *   perguntar`, mesmo shape do `view-chat.vue`.
     *
     * ★ `exibir` não é enfeite: as confirmações do two-step viajam como frase
     * de PROTOCOLO (o servidor a intercepta antes de o modelo vê-la), e sem o
     * segundo campo o protocolo cru apareceria como fala do consultor no
     * thread. O Guia já mandava os dois; aqui o parâmetro era descartado em
     * silêncio, o que só não aparecia porque este painel ainda não tinha
     * nenhuma superfície de confirmação além do envio do relatório.
     */
    async enviarPergunta(texto, { exibir, anexos } = {}) {
      const pergunta = (texto || '').trim()
      if (!pergunta || this.carregando) return
      this.mensagem = ''
      const r = await apiFeeFixoIa.perguntar({
        message: pergunta,
        exibir: exibir,
        contexto: this.contextoDaTela,
        rascunho: this.rascunhoDaTela,
        conversationId: this.conversationId,
        anexos: anexos,
      })
      // O stream reporta erro pelos próprios eventos; aqui só cai o que nem
      // chegou a abrir (rede, 403 da funcionalidade).
      if (r && r.status && r.status !== 200) this.$showSnack(r)
    },
    usarSugestao(texto) {
      this.enviarPergunta(texto)
    },
    cancelar() {
      apiFeeFixoIa.cancelRequest({ id: this.conversationId })
    },
    aoDigitar(valor) {
      this.mensagem = valor
    },
    rolarParaOFim() {
      this.$nextTick(() => {
        const el = this.$refs.listaMensagens
        if (el) el.scrollTop = el.scrollHeight
      })
    },
  },
}
</script>

<template>
  <!-- A moldura (superfície fixa à direita, aba recolhida, transições, botão de
       recolher) vem da casca compartilhada. Antes eram 56 linhas de CSS aqui,
       com 41 das 46 declarações byte-idênticas às dela — a aba era 19/19. -->
  <IaPainelLateral
    :aberto="aberto"
    titulo="Especialista em Fee Fixo"
    :subtitulo="rotuloContexto"
    rotulo-aba="Especialista"
    @abrir="abrir"
    @fechar="fechar"
  >
    <template v-slot:acoes>
      <button
        type="button"
        class="ia-painel-lateral__botao"
        aria-label="Nova conversa"
        title="Nova conversa"
        :disabled="carregando"
        @click="novaConversa"
      >
        <icon-svg name="add-circle" :size="18" color="var(--neutral-700)" />
      </button>
    </template>

    <div class="ff-ia-conteudo">
      <div ref="listaMensagens" class="ff-ia-mensagens">
          <!-- A MESMA composição do estado vazio do chat v2 — herói serifado,
               coluna alinhada à esquerda e centrada na vertical, pílulas. Era
               uma imitação local, e por isso nascia colada no topo e na borda
               esquerda: reusar o componente é o que impede a divergência de
               voltar a cada ajuste do v2. As sugestões vão por prop porque a
               store que ele consulta por padrão é a do CRM, não a deste painel. -->
          <EmptyMessages
            v-if="semMensagens"
            class="ff-ia-vazio"
            headline="Vamos falar sobre este cliente?"
            :sugestoes="sugestoes"
            @use-suggestion="usarSugestao"
          >
            <template v-slot:descricao>
              <p class="az-text-secondary mb-0">
                Tire dúvidas de conta e de argumento sem sair da tela. Os
                números vêm do diagnóstico salvo do cliente — quando não há
                cenário salvo, o agente diz isso em vez de estimar.
              </p>
            </template>
          </EmptyMessages>

          <div
            v-for="(msg, i) in mensagensParaExibir"
            :key="i"
            :class="[
              'ff-ia-msg',
              msg.role === 'user' ? 'ff-ia-msg--usuario' : 'ff-ia-msg--agente',
            ]"
          >
            <!-- Mensagem do usuário sai como TEXTO, sem passar por markdown:
                 o que o consultor digitou é literal (o redesign imersivo). -->
            <div v-if="msg.role === 'user'">{{ msg.content }}</div>
            <!-- ★ O renderizador ÚNICO da plataforma, e não o `vue-markdown`
                 direto: a allowlist do DOMPurify vive dentro dele desde o merge
                 de 27/08/2026 (veio do `ia-markdown`), e allowlist em dois
                 lugares é allowlist que diverge. `allow-html` não vai escrito
                 porque o default JÁ é o lado fechado (equivale ao
                 `:html="false"` de antes) — quem quiser HTML do modelo precisa
                 pedir, e aqui não se pede.
                 ★ `v-else` precisa ficar ADJACENTE ao `v-if` acima (regra do
                 Vue 2 — um elemento entre os dois quebra o par, e o `v-else`
                 vira incondicional, renderizando o markdown TAMBÉM dentro da
                 bolha do usuário). Por isso os chips de anexo (G-18/F-10)
                 vêm DEPOIS, não entre os dois. -->
            <AawzMarkdownRender v-else :source="msg.content" />
            <!-- Bloco técnico de anexos persistido.
                 [S-3, design-conformance 05/09] MESMO componente do anexo ao
                 vivo do chat CRM (`ComposerAttachments somente-leitura`) —
                 antes um chip PRÓPRIO (`AnexosPersistidosChips`), a mesma
                 divergência de anatomia do `chat-message.vue`, só que entre
                 as duas SUPERFÍCIES em vez de dentro da mesma bolha. -->
            <ComposerAttachments
              v-if="msg.itensAnexosPersistidos && msg.itensAnexosPersistidos.length"
              somente-leitura
              class="ff-ia-anexos"
              :arquivos="msg.itensAnexosPersistidos"
            />
          </div>

          <div v-if="carregando" class="ff-ia-msg ff-ia-msg--agente">
            <div v-if="ferramentasEmUso.length" class="ff-ia-ferramenta">
              Consultando o diagnóstico…
            </div>
            <AawzMarkdownRender
              v-if="respostaEmCurso"
              :source="respostaEmCurso"
            />
            <!-- O MESMO sinal do chat v2 (`chat-message-footer`): o "W" da
                 marca animado, no FIM da mensagem — onde o olho está durante o
                 streaming. Os dois `v-progress-circular` que existiam aqui
                 saíram por dois motivos: eram um segundo indicador de
                 movimento na mesma região, e nasciam PRETOS — a prop `color`
                 do Vuetify espera nome de cor do tema e vira classe CSS, então
                 `var(--success)` não resolvia e caía no default. -->
            <icon-svg
              class="ff-ia-pensando"
              name="ia-w-mark"
              :size="20"
              color="var(--aawz-green-color)"
              animated
            />
          </div>

          <!-- Os cartões das tools do turno ([I-1]): a ação oferecida com o
               botão, a recusa do guard com o motivo, a falha com o texto do
               erro. Mesmo renderizador do chat do CRM — cartão novo é uma
               entrada no UI_REGISTRY, não uma linha aqui.

               ★ [I-11] `chaves-ignoradas` tira os seis cartões do módulo, que
               têm dono nas telas dele (aqui, o de envio logo abaixo). -->
          <PartesDoTurno
            class="ff-ia-partes mt-3"
            :partes="partesDoTurno"
            :ultima-mensagem="ultimaMensagemDoAgente"
            :chaves-ignoradas="chavesDesenhadasPelaTela"
            store-module="feeFixoIa"
          />

          <!-- ★ A SIMULAÇÃO que a conversa montou (spec-007 [T108]), agora
               também AQUI (defeito Q9 linha 6, 2026-09-04).

               A chave `fee-fixo/simulacao-card` está em `chaves-ignoradas`
               acima porque quem desenha é "a tela dona" — e a tela dona pode
               não estar aberta: este drawer flutua sobre TODAS as telas do
               módulo, e o consultor pede a simulação de onde estiver. Com a
               chave descartada pelo renderizador e nenhum dono na tela de trás,
               o preview chegava só no texto e o two-step ficava sem superfície
               para se concluir — os `resultados` que o commit exige são
               calculados por ESTE card, no navegador.

               Store COMPARTILHADA com o Guia (`feeFixoIa/simulacaoPendente`):
               são duas superfícies do mesmo consultor, e só uma delas está
               visível por vez. Card SEM `data-teste` na raiz, decisão do
               próprio card — em Vue 2 o atributo não-prop de quem monta vence o
               do filho e o seletor na tela montada falharia. -->
          <v-fade-transition>
            <FeeFixoGuiaSimulacaoCard
              v-if="simulacaoPendente"
              class="ff-ia-simulacao mt-3"
              :inputs="simulacaoPendente.inputs"
              :premissas-declaradas="simulacaoPendente.premissasDeclaradas"
              :preview-id="simulacaoPendente.previewId"
              :processando="salvandoSimulacao || carregando"
              :aviso-carteira-pendente="simulacaoPendente.avisoCarteiraPendente"
              :erro-deposito="erroDoDepositoDaSimulacao"
              @confirmar="confirmarSimulacao"
              @cancelar="cancelarSimulacao"
              @redepositar="redepositarSimulacao"
            />
          </v-fade-transition>

          <!-- Card de envio do relatório (spec-005). Entra no fluxo da conversa,
               logo abaixo da resposta que o ofereceu. -->
          <v-fade-transition>
            <FeeFixoIaEnvioRelatorio
              v-if="previewEnvio"
              class="ff-ia-envio mt-3"
              :preview="previewEnvio"
              :etapa="envioEtapa"
              :resolvido="envioResolvido"
              :mensagem-erro="envioErro"
              :resultado="envioResultado"
              @enviar="enviarRelatorio"
              @cancelar="cancelarEnvio"
              @fechar="cancelarEnvio"
            />
          </v-fade-transition>
        </div>

        <!-- O composer é o MESMO do chat v2, só apontado para esta store
             (`store-module`): ele lê `selectedModel`/`supportedModels`/
             `thinkingEnabled` por `$store.state[storeModule]` e despacha no
             mesmo namespace. Antes daqui havia uma cópia à mão do textarea e do
             botão de enviar, que precisava perseguir a cada mudança o raio, a
             cor e o ícone do original — e ficou sem o seletor de modelo, que o
             backend desta rota sempre aceitou (o `post()` é herdado do
             `ResourceIaCrmChat`, que valida `model` com `is_supported`).
             `hide-disclaimer` acompanha o `view-chat`: o rodapé fica com a dica
             de teclado, e o aviso regulatório sai por outro caminho. -->
        <SendMessage
          :value="mensagem"
          :loading="carregando"
          :placeholder="placeholderDoComposer"
          store-module="feeFixoIa"
          show-attachments
          anexos-liberados
          :id-cliente-anexo="idClienteAnexo"
          hide-disclaimer
          @input="aoDigitar"
          @send="enviarDigitado"
          @abort="cancelar"
        />
    </div>
  </IaPainelLateral>
</template>

<style lang="sass" scoped>
// A anatomia da MOLDURA (superfície fixa, aba recolhida, transições, topo,
// título e subtítulo) saiu daqui para a partial global
// `modules/global/design/_ia-painel-lateral.sass`, via `IaPainelLateral`. Eram
// 56 linhas com 41 das 46 declarações byte-idênticas às de lá, mais ~33 de
// comentário reescrito quase palavra a palavra. Aqui ficou só o CONTEÚDO.

// Um único filho do slot: a casca entrega `__corpo` como coluna flex com
// `overflow: hidden`, e as mensagens precisam do seu próprio scroll.
.ff-ia-conteudo
  display: flex
  flex-direction: column
  flex: 1 1 auto
  min-height: 0

.ff-ia-mensagens
  flex: 1
  overflow-y: auto
  padding: 14px 16px

// O respiro lateral do estado vazio NÃO é acertado contra a borda do painel, e
// sim contra o COMPOSER — é ele que fica logo abaixo, na mesma tela, e é dele
// que o olho tira o prumo. Uma compensação negativa aqui puxava o herói para
// 25px enquanto o texto do composer nascia em 42px, e o bloco lia como colado
// na parede.
//
// Sem margem, a conta fecha sozinha: 16px do trilho (`.ff-ia-mensagens`) + os
// 24px do `pa-6` que o `EmptyMessages` traz = 40px, contra os 42px do composer
// (16px do `px-4` do rodapé + 25px do preenchimento da pílula). Medido em tela.
//
// No chat v2 de rota cheia esse alinhamento é de graça porque o composer sobe
// para DENTRO do herói (`composerNoHeroi`); aqui ele fica no rodapé, como no
// popup, então o prumo é feito na mão.
.ff-ia-vazio
  font-size: 12px

.ff-ia-sugestao
  display: block
  width: 100%
  text-align: left
  border: 1px solid var(--border-input)
  border-radius: 8px
  padding: 8px 10px
  margin-bottom: 6px
  font-size: 12px
  color: var(--neutral-700)
  transition: border-color 0.15s, background 0.15s

  &:hover
    border-color: var(--primary)
    background: var(--neutral-50)

// ★ [T019] A bolha NAO fixa mais o corpo do texto. Quem dimensiona o markdown
// e a folha `.markdown-style`, que o `ia-markdown` traz na raiz — e ela mistura
// absoluto com relativo: `p` em 14px fixos, `li` em `0.875em`. Com os 13px que
// moravam aqui, o `em` do `li` resolvia para 11,375px e o item de lista saia
// MENOR que o paragrafo que o apresenta (medido no browser em 26/08). Sem a
// declaracao, a bolha herda o mesmo contexto do thread do guia e os dois caem
// em 14px, que e a paridade que o guia ja tinha. O que nao e markdown dentro da
// bolha (`.ff-ia-ferramenta`) ja declara o proprio tamanho.
.ff-ia-msg
  line-height: 1.5
  margin-bottom: 10px
  padding: 9px 12px
  border-radius: 10px
  word-break: break-word

  // O recuo do marcador. A folha devolve o `circle` ao `li` e desenha o `ul`
  // como caixa flex, mas nao da recuo nenhum: o `_reset` global zera o
  // `padding-left` do `ul` e, com `list-style-position: outside` (o mesmo do
  // guia), o marcador e desenhado a ESQUERDA da caixa. Medido: sobrava 1px ate
  // a borda interna desta bolha, e o marcador ficava pendurado sobre o padding
  // de 12px. No guia o `ul` tambem vem sem recuo — la o `px-4` da bolha (16px)
  // o acomoda, e e esse mesmo 16px, o `.az-gap` default da escala AAWZ
  // (`design-system/tokens.json`, spacing/aawzGapScale/default), que entra aqui.
  // Precisa de `::v-deep` porque a lista e conteudo de componente FILHO: o
  // atributo de escopo so alcanca a raiz do `ia-markdown`, nunca o que ele
  // desenha dentro.
  ::v-deep .markdown-style ul,
  ::v-deep .markdown-style ol
    padding-left: 16px

// Valores copiados de `.user-bubble` em `chat-message.vue` — inclusive o raio
// assimétrico, que é o que dá o "rabinho" do lado de quem falou.
//
// `fit-content` + `margin-left: auto` é o que o v2 faz com
// `d-flex justify-end` na linha: o balão encolhe até o texto e encosta na
// direita. Aqui não dá para usar a linha flex — `.ff-ia-mensagens` é o
// container de scroll e precisa continuar block —, então a mesma medida
// (`max-width: 85%`) vem pelo próprio balão.
.ff-ia-msg--usuario
  background: var(--neutral-100)
  border: 1px solid var(--border-input)
  color: var(--neutral-900)
  border-radius: 16px 16px 6px 16px
  width: fit-content
  max-width: 85%
  margin-left: auto

// A resposta do agente NÃO tem caixa, como no v2 (`.assistant-content`): texto
// solto de largura cheia, estilo ChatGPT/Claude. A caixa branca com borda que
// existia aqui era o principal ponto fora do padrão.
.ff-ia-msg--agente
  background: transparent
  padding-left: 0
  padding-right: 0
  margin-right: 0

.ff-ia-ferramenta
  font-size: 11px
  color: var(--secondary)

// Mesmo tratamento do `.chat-message-footer__thinking-icon` do v2: `icon-svg`
// carrega a global `.full-center` (flex sem largura própria), que dentro de um
// pai block estica para 100% e centraliza o glifo no meio da linha; e o glifo
// tem margem interna só à direita, daí os 4px que o realinham com o texto.
.ff-ia-pensando
  display: inline-flex
  flex-shrink: 0
  padding-left: 4px

</style>
